var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',_vm._g(_vm._b({class:{ 'on-hover': hover },attrs:{"elevation":hover? 12:2,"height":"auto"}},'v-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }